module.exports = __webpack_public_path__ + "static/img/bg.2c22995c.png";